import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../global/Navbar";
import CourseRating from "../components/Dashbord/Geust/CourseRating";
import axios from "axios";
import PaymentModal from "../components/Details/PaymentModal";



const BookDetails = () => {
  
  const [showModal, setShowModal] = useState(false);
  const [book, setBook] = useState([]);

  const { id } = useParams();
 

    const fetchBooks = async () => {
		try {
		const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/books/${id}`);
		setBook(response.data);
		} catch (error) {
		console.error("Failed to fetch books:", error.response?.data || error.message);
		}
  	};

  fetchBooks();
  
  const selectValue = "book"


  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#101e2b] ">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0 mt-[5rem] mb-[5rem]">
        <div className="w-full flex lg:flex-row flex-col gap-4">
          <div className="lg:w-4/5 w-full flex md:flex-row flex-col gap-8">
            <div className="md:w-1/3 w-full">
              <div className="border border-[#22BEFF33] p-4 flex justify-center items-center">
                <img src={`${import.meta.env.VITE_API_BASE_URL}/storage/${book?.image}`} alt="book_details" className="rounded-tl-md rounded-tr-md "/>
              </div>
            </div>
            <div className="md:w-2/3 w-full flex flex-col gap-4">
              <h2 className="text-2xl font-bold text-gray-300">{book?.title}</h2>
              <span className="text-base text-gray-300">
                by <span className="text-[#22BEFF]">{book?.author_name}</span>
              </span>
              <span className="text-base text-gray-300">
                Category:{" "}
                <span className="text-[#22BEFF]">Book</span>
              </span>
              <CourseRating value={5} />
              <span className="text-xl font-bold text-[#22BEFF] flex gap-4">
                {book?.current_price}/-{" "}
                <del className="text-red-500 font-medium">
                  {book?.regular_price}/-
                </del>
              </span>

              <p className="text-base text-gray-400">{book.seo_description}</p>

              <div className="w-full border border-[#22BEFF33] p-3 rounded-md flex gap-2">
                <img src={`${import.meta.env.VITE_API_BASE_URL}/storage/${book?.image}`} alt="image" className="w-[3rem] h-[3rem] rounded-md" loading="lazy"/>

                <div className="flex flex-col justify-center gap-2">
                  <span className="text-gray-400 font-bold text-sm">
                    Get eBook Version
                  </span>
                  {/* <span className="text-base text-gray-400">
                    TK. 50
                  </span> */}
                </div>
              </div>

              {/* <div className="w-full border border-[#22BEFF33] p-3 rounded-md flex gap-2">
                <span className="text-base text-gray-400">{book.offer}</span>
              </div> */}

              <div className="flex items-start gap-4 mt-4">
                <button className="px-[1.25rem] py-[0.8rem] text-base border border-[#22beff] text-[#22beff] hover:text-[#081a28] hover:bg-[#22beff] rounded-md font-medium cursor-pointer" onClick={() => window.open(`${import.meta.env.VITE_API_BASE_URL}/storage/${book.pdf}`, "_blank")} >
                  একটু পড়ে দেখুন
                </button>

                <button  onClick={() => setShowModal(true)} className="px-[1.25rem] py-[0.8rem] text-base border border-[#22beff] bg-[#22beff] text-[#081a28] rounded-md font-medium cursor-pointer">
                  বইটি কিনুন
                </button>
              </div>
            </div>
          </div>
         
        </div>

      </div>

      <PaymentModal showModal={showModal} setShowModal={setShowModal} id={id} selectValue={selectValue}/>
    </div>
  );
};

export default BookDetails;